import { CorePropsInterfaces, DTOs } from "src/core/Models";
import * as Constants from "./../../core/Constants";

import { useMemo, useContext } from "react";
import { AppContext } from "src/contexts/AppContext";
import { isFinalorOutdatedVersion } from "src/utils";
import EngagementServiceTasksPanel from "./EngagementServiceTasksPanel";

export default function EngagementServiceTasksPanelWrapper({
  serviceDTO,
  onExpandChange,
  children,
}: CorePropsInterfaces.EngagementServiceTasksPanelWrapperProps) {
  const { globalState, dispatch } = useContext(AppContext);
  const generalVariables = globalState.generalVariables;
  const currentRateCartConfiguration =
    globalState.currentConfiguration?.applicationConfiguration
      ?.rateCartConfiguration;

  const serviceChangeToken = (service: DTOs.ServiceDTO): string => {
    const serviceToken = `${service.data.code}_${service.state.isExpandedEngagementDescriptionAccordion}`;

    const taskTokens = service.data.tasks.map((task: DTOs.TaskDTO) => {
      return `${task.data.code}_${task.state.isVisible ? `1` : `0`}_${
        task.state.isActive ? `1` : `0`
      }_${task.data.adjustments.frequency}_${
        task.data.adjustments.allocationOfResponsibility
      }_${task.data.adjustments.estimatedTimePerUnit}_${
        task.data.adjustments.comment
      }_${task.data.adjustments.estimatedTimePerUnit}_${
        task.data.adjustments.staffLevel
      }`;
    });

    const token: string = serviceToken + "^^" + taskTokens.join("|");

    return token;
  };

  let serviceToken = serviceChangeToken(serviceDTO);
  const isFinalorOutdatedVersionStatus = isFinalorOutdatedVersion(globalState);
  const lastConfigurationModifiedDate =
    globalState.currentConfiguration.lastModifiedDate;
  const extraProcessingServices: Array<DTOs.ServiceDTO> = [];
  if (serviceDTO.data.code === Constants.ServiceCode.AnnualPayrollRoutines) {
    const payrollService = globalState.services.find(
      (eachService) =>
        eachService.data.code ===
        Constants.ServiceCode.PayrollAndExpenseAndTravelInvoiceManagement
    );
    extraProcessingServices.push(payrollService);
    serviceToken += serviceChangeToken(payrollService);
  }
  const memoizedComponent = useMemo(
    () => (
      <EngagementServiceTasksPanel
        serviceDTO={serviceDTO}
        generalVariables={generalVariables}
        dispatch={dispatch}
        isFinalorOutdatedVersionStatus={isFinalorOutdatedVersionStatus}
        lastConfigurationModifiedDate={lastConfigurationModifiedDate}
        extraProcessingServices={extraProcessingServices}
        onExpandChange={onExpandChange}
        rateCartConfiguration={currentRateCartConfiguration}
      >
        {children && children}
      </EngagementServiceTasksPanel>
    ),
    [
      serviceToken,
      isFinalorOutdatedVersionStatus,
      lastConfigurationModifiedDate,
    ]
  );

  return memoizedComponent;
}
